import styled from "styled-components"
import { fonts } from "../../../utils/styles"
import { FlexipageColors } from "../../Flexipage/Global/FlexipageStyles"

export const TrulyGlobalWrapper = styled.section`

  h4 {
    font-family: ${fonts.nunito};
  }

  .truly-global {
    color: #428ac9;

    @media (max-width: 992px) {
      font-size: 1.75rem;
    }
  }

  .filters {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 2rem;
    margin-bottom: 3rem;

    @media (max-width: ${FlexipageColors.breakpointMobile}) {
      flex-direction: column;
    }
  }

  .filter-item {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1rem;

      // @media (max-width: ${FlexipageColors.breakpointMobile}) {
    //   flex-direction: column;
    //   align-items: flex-start;
    //   gap: 0.5rem;
    // }
  }

  select {
    background-color: #F3F6F7;
    border: 1px solid #E7ECEE;
    color: ${FlexipageColors.blue1000}
    padding: 0.5rem 1rem;
  }

  .radios {
    display: flex;
    gap: 2rem;
    padding: 0.5rem 1rem;
    background-color: #F3F6F7;
    border: 1px solid #E7ECEE;
    border-radius: 0.5rem;

    .form-check-inline {
      gap: 0.5rem;
      margin: 0;
    }

    @supports (appearance: none) {
      input[type="radio"] {
        appearance: none;
        display: flex;
        width: 1.5rem;
        height: 1.5rem;
        padding: 0.25rem;
        margin: 0;
        box-sizing: border-box;
        background-color: #F9F9F9;
        border: 1px solid #E7ECEE;
        border-radius: 50%;

        &::after {
          content: '';
          width: 100%;
          height: 100%;
          border-radius: 50%;
        }

        &:checked::after {
          background-color: ${FlexipageColors.teal1000};
        }
      }
    }

    label {
      color: ${FlexipageColors.blue1000}
    }
  }

  .tr-img {
    width: 100%;
    margin: auto;
    margin-bottom: 20px;
  }

  #local-processors {
    .location-header {
      text-align: center;
    }

    .logos {
      position: relative;
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
      gap: 22px;

      .logo {
        position: relative;
        aspect-ratio: 12 / 7;
        border: 1px solid #E7ECEE;
        border-radius: 0.25rem;
        max-width: 100%;

        img {
          --_margin-block: 10px;
          --_margin-inline: 20px;

          position: absolute;
          inset: var(--_margin-block) var(--_margin-inline);
          width: calc(100% - var(--_margin-inline) * 2);
          height: calc(100% - var(--_margin-block) * 2);
          object-fit: contain;
        }
      }
    }

    .button-select {
      background-color: #698795 !important;
      font-size: 1.25rem;
      @media screen and (max-width: 991px) {
        font-size: 1rem;
      }

      &.selected {
        background-color: #134056 !important;
      }
    }

  }

  .connecting-leading-acquirers {
    max-width: 800px;
  }

`
